import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ErrorService } from '../../../../core/services/error.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { GetTimeComponent } from '../../dialogs/get-time/get-time.component';
import { MyButtonComponent } from '../../buttons/my-button/my-button.component';

@Component({
  selector: 'app-input-time',
  templateUrl: './input-time.component.html',
  styleUrls: ['./input-time.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MyButtonComponent
  ]
})
export class InputTimeComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() icon?: string;
  @Input() placeholder: string = '';
  @Input() hint?: string;
  @Input() form!: FormGroup;
  @Input() type: string = 'text';
  @Input() class: string = '';
  @Input({
    transform: booleanAttribute,
  }) showSeconds: boolean = false;

  constructor(
    private errorService: ErrorService,
    private dialogService: DialogService
  ) { }

  hasError() {
    return this.form.get(this.name)?.invalid && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched);
  }

  error() {
    const errors = Object.entries(
      this.form.get(this.name)?.errors || {}
    );
    return this.errorService.getErrorValidationMessage(this.name, errors);
  }

  openGetTimeDialog(): void {
    const dialogRef = this.dialogService.open(GetTimeComponent, {
      data: {
        showSeconds: this.showSeconds
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let time = `${result.hours.toString().padStart(2, '0')}:${result.minutes.toString().padStart(2, '0')}`;
        time += this.showSeconds ? `:${result.seconds.toString().padStart(2, '0')}` : '';
        this.form.get(this.name)?.setValue(time);
      }
    });
  }
}
